"use client";
import React from "react";
import { usePathname } from "next/navigation";
import Image from "next/image";
import Link from "next/link";
import { FRONTEND_ENDPOINTS } from "@/public/Constants/endpoints";
import { PAGE_TITLES } from "@/public/Constants/EnumConstants";
import TypographyPoppins from "@/components/Atoms/TypographyPoppins";
import { BreadcrumbRightArrow } from "@/public/Theme";

function slugToTitle(slug) {
    return slug
        .split("-") // split by hyphen
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // capitalize first letter
        .join(" "); // join with space
}

const ProductsBreadCrumbs = () => {
    const pathName = usePathname();
    const breadcrumbs = pathName?.substring(1)?.split("/");

    breadcrumbs?.shift();
    let breadcrumbLink = FRONTEND_ENDPOINTS?.SHOP;
    return (
        <div className={"flex items-center mb-5"}>
            <Link href={FRONTEND_ENDPOINTS?.SHOP} prefetch>
                <TypographyPoppins
                    color={"Text_Gray"}
                    fontWeight={"light"}
                    customStyle={"!text-[10px] sm:!text-xs"}
                    text={"Shop"}
                />
            </Link>
            {breadcrumbs?.map((breadcrumb, index) => {
                const currentLink = index + 1 === breadcrumbs?.length;
                breadcrumbLink += "/" + breadcrumb;
                let textColor = currentLink ? null : "Text_Gray";
                let fontWeight = currentLink ? "medium" : "light";
                // if there is boxId in query then show the boxId Constant
                // instead of Page titles array
                let pageTitle =
                    PAGE_TITLES[breadcrumb] || slugToTitle(breadcrumb);
                return (
                    <div className={"flex items-center"} key={index}>
                        <div className={""}>
                            <Image
                                alt="breadcrumbs-right-arrow"
                                height={14}
                                width={14}
                                src={BreadcrumbRightArrow}
                                className={"h-[14px]"}
                            />
                        </div>
                        <Link href={breadcrumbLink} prefetch>
                            <TypographyPoppins
                                color={textColor}
                                fontWeight={fontWeight}
                                size={"sm"}
                                text={pageTitle}
                                customStyle={`!text-[10px] sm:!text-xs ${
                                    currentLink ? "underline" : ""
                                }`}
                            />
                        </Link>
                    </div>
                );
            })}
        </div>
    );
};

export default ProductsBreadCrumbs;
